<template>
  <div class="mall-order-detail-products">
    <div class="mall-order-detail-products__head">
      <span class="mall-order-detail-products__count">주문상품 {{ items.length }}개</span>
      <span class="mall-order-detail-products__add-all" @click="$emit('add-all-click')">모든 상품 장바구니 담기</span>
    </div>
    <template v-for="(item, index) in items">
      <div v-if="index > 0" :key="item.id + '-divider'" class="mall-order-detail-products__divider"></div>
      <div :key="item.id" class="mall-order-detail-products__item">
        <img v-if="item.image" class="mall-order-detail-products__thumb" :src="item.image" :alt="item.name" />
        <div v-else class="mall-order-detail-products__thumb mall-order-detail-products__thumb--empty"></div>
        <div class="mall-order-detail-products__info">
          <div class="mall-order-detail-products__text">
            <div class="mall-order-detail-products__status-row">
              <span
                class="mall-order-detail-products__status"
                :class="{ 'mall-order-detail-products__status--active': isActiveStatus(item.status) }"
              >{{ statusLabels[item.status] }}</span>
              <img src="@/assets/mall/icn_dot_fill.svg" alt="" />
              <span class="mall-order-detail-products__date">{{ item.date }}</span>
            </div>
            <span v-if="item.categoryLabel" class="mall-order-detail-products__category">{{ item.categoryLabel }}</span>
            <span class="mall-order-detail-products__name">{{ item.name }}</span>
            <span class="mall-order-detail-products__price">
              <template v-if="item.price !== null">{{ formatNumber(item.price) }}원 / </template>수량 {{ item.quantity }} 개
            </span>
          </div>
          <div v-if="item.canRebuy" class="mall-order-detail-products__buttons">
            <MallButton :label="'재구매'" :type="'secondary'" :size="'sm'" @click="$emit('rebuy-click', item)" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import convert from '@/utilities/convert.js'
import MallButton from '@/components/new/atoms/MallButton.vue'

// 배송이 진행 중인 상태는 파란색으로 강조
var ACTIVE_STATUSES = ['paid', 'waiting', 'preparing', 'shipping']

export default {
  name: 'MallOrderDetailProducts',
  components: {
    MallButton,
  },
  props: {
    // [{ id, status, date, categoryLabel, name, image, price(개당, 없으면 null), quantity, canRebuy }]
    // image가 비어 있으면 빈 이미지 칸
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      statusLabels: {
        paid: '결제완료',
        waiting: '배송대기',
        preparing: '상품준비중',
        shipping: '배송중',
        delivered: '배송완료',
        canceled: '주문취소',
        refunded: '환불',
      },
    }
  },
  methods: {
    isActiveStatus(status) {
      return ACTIVE_STATUSES.indexOf(status) > -1
    },
    formatNumber(value) {
      return convert.setComma(value)
    },
  },
}
</script>

<style scoped>
.mall-order-detail-products {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mall-order-detail-products__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mall-order-detail-products__count {
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-order-detail-products__add-all {
  padding: 0 2px;
  border-radius: 4px;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
}

.mall-order-detail-products__divider {
  height: 1px;
  background: #F2F4F6;
}

.mall-order-detail-products__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.mall-order-detail-products__thumb {
  display: block;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}

.mall-order-detail-products__thumb--empty {
  background: #F2F4F6;
}

.mall-order-detail-products__info {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.mall-order-detail-products__text {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 2px;
  font-family: Pretendard;
  font-weight: var(--font-weight-medium);
}

.mall-order-detail-products__status-row {
  display: flex;
  align-items: center;
}

.mall-order-detail-products__status-row img {
  display: block;
}

/* 13px 텍스트는 Figma 렌더링 기준(150% → 20px 반올림)으로 맞춤 */
.mall-order-detail-products__status,
.mall-order-detail-products__date,
.mall-order-detail-products__category {
  font-size: var(--font-size-xs);
  line-height: 20px;
  white-space: nowrap;
}

.mall-order-detail-products__status {
  color: var(--color-text-main);
}

.mall-order-detail-products__status--active {
  color: #0096FF;
}

.mall-order-detail-products__date {
  color: #4E5968;
}

.mall-order-detail-products__category {
  color: #8B95A1;
}

.mall-order-detail-products__name {
  color: #4E5968;
  font-size: var(--font-size-md);
  line-height: var(--line-height-normal);
  overflow-wrap: anywhere;
}

.mall-order-detail-products__price {
  color: #4E5968;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
}

.mall-order-detail-products__buttons {
  display: flex;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallOrderDetailProducts.vue